import { Action, createAction, handleActions } from 'redux-actions'
import { takeLatest } from 'redux-saga/effects'
import { oc } from 'ts-optchain'

import { fetchHelpList, IHelpCategoryResponse } from '@/api/CmsApi'
import { IRootState } from '@/modules'
import { createFetchAction, createSaga } from '@/utils/actionUtils'
import { apiFailureReducer } from '@/utils/reducerUtils'

export interface ISupportView {
  isFocus: boolean
  searchWord: string
  selectedCategoryIndex: number
  openedDetailIndex: string
}

interface ISupportState {
  list: IHelpCategoryResponse[]
  view: ISupportView
}

export const defaultView: ISupportView = {
  isFocus: false,
  searchWord: '',
  selectedCategoryIndex: -1,
  openedDetailIndex: '',
}

const initialState: ISupportState = {
  list: [],
  view: defaultView,
}

export const SUPPORT = 'Support'
export const FETCH_SUPPORT_LIST = `${SUPPORT}/fetchSupportList`
export const SET_VIEW = `${SUPPORT}/setView`

export const supportActions = {
  setView: createAction(SET_VIEW),
}

export const supportFetchSupportListAsync = createFetchAction(FETCH_SUPPORT_LIST)

export const reducer = {
  [supportFetchSupportListAsync.SUCCESS]: (state: ISupportState, action: Action<any>) => ({
    ...state,
    list: action.payload.helps,
  }),
  [supportFetchSupportListAsync.FAILURE]: apiFailureReducer,
  [SET_VIEW]: (state: ISupportState, action: Action<any>) => ({
    ...state,
    view: {
      ...state.view,
      ...action.payload,
    },
  }),
}

export const supportSelector = {
  view: (state: IRootState) => oc(state[SUPPORT]).view(defaultView),
  isSearching: (state: IRootState) => {
    const { isFocus, searchWord, selectedCategoryIndex } = oc(state[SUPPORT]).view(defaultView)

    return isFocus || !!searchWord || selectedCategoryIndex !== -1
  },
  list: (state: IRootState) => oc(state[SUPPORT]).list([]),
}

export const supportReducer = handleActions(reducer, initialState)
export const supportSaga = [
  takeLatest(
    supportFetchSupportListAsync.FETCH,
    createSaga(supportFetchSupportListAsync, fetchHelpList),
  ),
]
